import React,{useState , useEffect} from 'react';
import {storage} from "../../firebase/index"
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {Container, Grid} from "@material-ui/core"
import Button from "@material-ui/core/Button"
import {connect} from "react-redux"
import Blue from "@material-ui/core/colors/blue"
import Spinner from "../../UI/Spinner/spinner"
import TextAreaAutosize from "@material-ui/core/TextareaAutosize"
import { blue } from '@material-ui/core/colors';
import violet from "../../demo/violetEvergarden.png"
import Typography from "@material-ui/core/Typography"
import 'semantic-ui-css/semantic.min.css'
import { Redirect } from 'react-router-dom';
const formColor = blue[500];
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '32ch',
    },
     borderRadius:"12px",
    paddingBottom:"45px",
    paddingTop:"45px",
    

},
imghandle:{
  width:"80%",
  height:"40%",
 borderRadius:"12px",
},
    
  background:{
    
      padding:"19%",
      backgroundColor:Blue[800]
  },
  bottom:{
      backgroundColor:formColor,
      color:"white"
    },
    publish:{
        fontFamily:[
            'Luckiest Guy', "cursive"
      ],
    
    },
    fieldColor:{
      backgroundColor:"transparent",
    }
}));

const db = storage.firestore()

const addButton= React.memo(props=>{
 
 
  const [url,setUrl] = useState("")
  const [nameState , setNameState] = useState('')
const [imageState , setImageState] = useState('')
const [descriptionstate , setDescriptionState] = useState('')
const [submit , setSubmit] = useState(false)
const nameChangeHandler=(event)=>{
setNameState(event.target.value)
}
const imageChangeHandler=async(event)=>{
//setImageState(event.target.value)
const file = event.target.files[0];
const storageRef = storage.storage().ref()
const fileRef = storageRef.child(file.name)
await fileRef.put(file)
setUrl(await fileRef.getDownloadURL())

}
const descriptionChangeHandler=(event)=>{
setDescriptionState (event.target.value)
}

const submitHandler=(event)=>{

    console.log("submitted")

    const data={
      name:nameState,
      image:imageState,
      description:descriptionstate,   
    } 

    event.preventDefault();
  
    const username  = event.target.username.value
    const description = event.target.description.value
    if(!username || !url){
      return
    }
  
      db.collection("users").doc(username , description).set({
        name:username,
        avatar:url,
        description:description
      
      })


};



  const classes = useStyles();


 

              
  return (
  
  <Container maxWidth="xl" className={classes.background}>
  <Grid container>
  <Grid item md="6" xs="6"   >

  <Typography className={classes.publish} variant="h3">Add Your Anime</Typography> 
  <form onSubmit={submitHandler} className={classes.root} noValidate autoComplete="off">
    
  
    <TextField id="outlined-basic" 
    label="Anime Name" 
    name="username"
      variant="outlined" 
      value={nameState}
      onChange={nameChangeHandler} 
         />
  <br/>
  
  
    <TextField id="outlined-basic" 
    label="Image" variant="outlined"
      type="file" 
      onChange={imageChangeHandler} />
    <br/> 
        

  
  <TextAreaAutosize rowsMin={3} 
  className={classes.publish} 
  placeholder="Description"
  name="description"
  className={classes.fieldColor}
    value={descriptionstate} 
    onChange={descriptionChangeHandler}
    aria-label="maximum height"/>
<br/>
    
<Button variant="contained" 
  className={classes.bottom}
  type="submit"  >
  <Typography  className={classes.publish} variant="h5"> Publish</Typography></Button>

  </form>
</Grid>
<Grid item md="6" xs="6" >
  <img src={violet} className={classes.imghandle} alt="violet"/>
</Grid>

</Grid>

    </Container>
  
);
})
export default addButton


// WEBPACK FOOTER //
// ./src/Component/postAnime/AddAnime.jsx